export const STAFF_DIALOG_WIDTH = "sm:max-w-[530px]";
export const STAFF_DIALOG_HEIGHT = "max-h-[90vh]";

export const STAFF_DIALOG_STEPS = [
  { id: "info", label: "Info" },
  { id: "hours", label: "Hours" },
  { id: "services", label: "Services" },
];

export const TIME_OPTIONS = Array.from({ length: 96 }, (_, i) => {
  const totalMinutes = i * 15;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
});

export const DAY_OF_WEEK_LABEL: Record<number, string> = {
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
  7: "Sunday",
};
